package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class ExpenseListQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    name: String,
    description: String?,
    status: String,
    date: String?,
    recurrence: String,
    next_reset_date: String?,
    last_reset_date: String?,
    reset_mode: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(93_490_029, arrayOf("expense_list"), driver, "ExpenseList.sq",
      "selectAll",
      "SELECT expense_list.id, expense_list.name, expense_list.description, expense_list.status, expense_list.date, expense_list.recurrence, expense_list.next_reset_date, expense_list.last_reset_date, expense_list.reset_mode, expense_list.order_index, expense_list.created_at, expense_list.updated_at, expense_list.is_deleted, expense_list.deleted_at, expense_list.synced_at FROM expense_list WHERE is_deleted = 0 ORDER BY status, order_index, created_at DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectAll(): Query<Expense_list> = selectAll { id, name, description, status, date,
      recurrence, next_reset_date, last_reset_date, reset_mode, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Expense_list(
      id,
      name,
      description,
      status,
      date,
      recurrence,
      next_reset_date,
      last_reset_date,
      reset_mode,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    name: String,
    description: String?,
    status: String,
    date: String?,
    recurrence: String,
    next_reset_date: String?,
    last_reset_date: String?,
    reset_mode: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectById(id: String): Query<Expense_list> = selectById(id) { id_, name, description,
      status, date, recurrence, next_reset_date, last_reset_date, reset_mode, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Expense_list(
      id_,
      name,
      description,
      status,
      date,
      recurrence,
      next_reset_date,
      last_reset_date,
      reset_mode,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDueReset(next_reset_date: String?, mapper: (
    id: String,
    name: String,
    description: String?,
    status: String,
    date: String?,
    recurrence: String,
    next_reset_date: String,
    last_reset_date: String?,
    reset_mode: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectDueResetQuery(next_reset_date) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getString(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectDueReset(next_reset_date: String?): Query<SelectDueReset> =
      selectDueReset(next_reset_date) { id, name, description, status, date, recurrence,
      next_reset_date_, last_reset_date, reset_mode, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    SelectDueReset(
      id,
      name,
      description,
      status,
      date,
      recurrence,
      next_reset_date_,
      last_reset_date,
      reset_mode,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    name: String,
    description: String?,
    status: String,
    date: String?,
    recurrence: String,
    next_reset_date: String?,
    last_reset_date: String?,
    reset_mode: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-347_704_674, arrayOf("expense_list"), driver, "ExpenseList.sq",
      "selectDirty",
      "SELECT expense_list.id, expense_list.name, expense_list.description, expense_list.status, expense_list.date, expense_list.recurrence, expense_list.next_reset_date, expense_list.last_reset_date, expense_list.reset_mode, expense_list.order_index, expense_list.created_at, expense_list.updated_at, expense_list.is_deleted, expense_list.deleted_at, expense_list.synced_at FROM expense_list WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectDirty(): Query<Expense_list> = selectDirty { id, name, description, status, date,
      recurrence, next_reset_date, last_reset_date, reset_mode, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Expense_list(
      id,
      name,
      description,
      status,
      date,
      recurrence,
      next_reset_date,
      last_reset_date,
      reset_mode,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    name: String,
    description: String?,
    status: String,
    date: String?,
    recurrence: String,
    next_reset_date: String?,
    last_reset_date: String?,
    reset_mode: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Expense_list> = selectByIdAnyState(id) { id_,
      name, description, status, date, recurrence, next_reset_date, last_reset_date, reset_mode,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Expense_list(
      id_,
      name,
      description,
      status,
      date,
      recurrence,
      next_reset_date,
      last_reset_date,
      reset_mode,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    name: String,
    description: String?,
    status: String,
    date: String?,
    recurrence: String,
    next_reset_date: String?,
    last_reset_date: String?,
    reset_mode: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(2_005_019_473, """
        |INSERT INTO expense_list(
        |    id, name, description, status, date, recurrence, next_reset_date, last_reset_date,
        |    reset_mode, order_index, created_at, updated_at
        |) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 12) {
          bindString(0, id)
          bindString(1, name)
          bindString(2, description)
          bindString(3, status)
          bindString(4, date)
          bindString(5, recurrence)
          bindString(6, next_reset_date)
          bindString(7, last_reset_date)
          bindString(8, reset_mode)
          bindLong(9, order_index)
          bindLong(10, created_at)
          bindLong(11, updated_at)
        }
    notifyQueries(2_005_019_473) { emit ->
      emit("expense_list")
    }
  }

  public fun update(
    name: String,
    description: String?,
    status: String,
    date: String?,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_945_001_631, """
        |UPDATE expense_list
        |SET name = ?, description = ?, status = ?, date = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 7) {
          bindString(0, name)
          bindString(1, description)
          bindString(2, status)
          bindString(3, date)
          bindLong(4, order_index)
          bindLong(5, updated_at)
          bindString(6, id)
        }
    notifyQueries(-1_945_001_631) { emit ->
      emit("expense_list")
    }
  }

  public fun updateFromRemote(
    name: String,
    description: String?,
    status: String,
    date: String?,
    recurrence: String,
    next_reset_date: String?,
    last_reset_date: String?,
    reset_mode: String,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_630_794_543, """
        |UPDATE expense_list
        |SET name = ?, description = ?, status = ?, date = ?, recurrence = ?, next_reset_date = ?,
        |    last_reset_date = ?, reset_mode = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 11) {
          bindString(0, name)
          bindString(1, description)
          bindString(2, status)
          bindString(3, date)
          bindString(4, recurrence)
          bindString(5, next_reset_date)
          bindString(6, last_reset_date)
          bindString(7, reset_mode)
          bindLong(8, order_index)
          bindLong(9, updated_at)
          bindString(10, id)
        }
    notifyQueries(-1_630_794_543) { emit ->
      emit("expense_list")
    }
  }

  public fun setRecurrence(
    recurrence: String,
    reset_mode: String,
    next_reset_date: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(723_606_938,
        """UPDATE expense_list SET recurrence = ?, reset_mode = ?, next_reset_date = ?, updated_at = ? WHERE id = ?""",
        5) {
          bindString(0, recurrence)
          bindString(1, reset_mode)
          bindString(2, next_reset_date)
          bindLong(3, updated_at)
          bindString(4, id)
        }
    notifyQueries(723_606_938) { emit ->
      emit("expense_list")
    }
  }

  public fun advanceReset(
    last_reset_date: String?,
    next_reset_date: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_034_216_315,
        """UPDATE expense_list SET last_reset_date = ?, next_reset_date = ?, updated_at = ? WHERE id = ?""",
        4) {
          bindString(0, last_reset_date)
          bindString(1, next_reset_date)
          bindLong(2, updated_at)
          bindString(3, id)
        }
    notifyQueries(-1_034_216_315) { emit ->
      emit("expense_list")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-335_840_499,
        """UPDATE expense_list SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-335_840_499) { emit ->
      emit("expense_list")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_166_441_718,
        """UPDATE expense_list SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_166_441_718) { emit ->
      emit("expense_list")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(-515_902_706, """DELETE FROM expense_list WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(-515_902_706) { emit ->
      emit("expense_list")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(867_053_119,
        """UPDATE expense_list SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(867_053_119) { emit ->
      emit("expense_list")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("expense_list", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("expense_list", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_396_735_098,
        """SELECT expense_list.id, expense_list.name, expense_list.description, expense_list.status, expense_list.date, expense_list.recurrence, expense_list.next_reset_date, expense_list.last_reset_date, expense_list.reset_mode, expense_list.order_index, expense_list.created_at, expense_list.updated_at, expense_list.is_deleted, expense_list.deleted_at, expense_list.synced_at FROM expense_list WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "ExpenseList.sq:selectById"
  }

  private inner class SelectDueResetQuery<out T : Any>(
    public val next_reset_date: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("expense_list", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("expense_list", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_647_743_633, """
    |SELECT expense_list.id, expense_list.name, expense_list.description, expense_list.status, expense_list.date, expense_list.recurrence, expense_list.next_reset_date, expense_list.last_reset_date, expense_list.reset_mode, expense_list.order_index, expense_list.created_at, expense_list.updated_at, expense_list.is_deleted, expense_list.deleted_at, expense_list.synced_at FROM expense_list
    |WHERE is_deleted = 0 AND recurrence != 'once'
    |  AND next_reset_date IS NOT NULL AND next_reset_date <= ?
    |ORDER BY next_reset_date
    """.trimMargin(), mapper, 1) {
      bindString(0, next_reset_date)
    }

    override fun toString(): String = "ExpenseList.sq:selectDueReset"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("expense_list", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("expense_list", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(213_561_259,
        """SELECT expense_list.id, expense_list.name, expense_list.description, expense_list.status, expense_list.date, expense_list.recurrence, expense_list.next_reset_date, expense_list.last_reset_date, expense_list.reset_mode, expense_list.order_index, expense_list.created_at, expense_list.updated_at, expense_list.is_deleted, expense_list.deleted_at, expense_list.synced_at FROM expense_list WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "ExpenseList.sq:selectByIdAnyState"
  }
}
